import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { loggedInUserGuid } from "../../store/iam/selectors";
import { fetchUser } from "../../store/users/operations";
import { getUserWithId } from "../../store/users/selectors";
import { Tag, ProgressBar, Icon} from "@blueprintjs/core";

class ProfileCompleteness extends Component{

    componentDidMount(){
        this.props.fetchUser(this.props.myGuid);
    }

    render(){
        let has_avatar , has_address, has_biography = false;
        let progress_bar_value = 0.0;
        let completeness = 0;
        if(this.props.my_profile){
            if(this.props.my_profile.image_url && this.props.my_profile.image_url.length){
                has_avatar = true;
                progress_bar_value += 0.15;
                completeness += 15; 
            }

            if(this.props.my_profile.address && this.props.my_profile.address.length){
                has_address = true;
                progress_bar_value += 0.5;
                completeness += 50; 
            }

            if(this.props.my_profile.description && this.props.my_profile.description.length){
                has_biography = true;
                progress_bar_value += 0.35;
                completeness += 35; 
            }
        }

        return(
            <>
            { this.props.my_profile &&
            <div className="profile-completeness">
                <h1><Translate value="profile_completeness.heading" /> {completeness}%</h1>
                <p><Translate value="profile_completeness.subheading" /></p>
                <ProgressBar intent="primary" value={progress_bar_value} animate={false} />
                <div className={`completeness-item ${has_avatar?"completed":""}`}>
                    <div className="label">          
                        <Icon
                            icon="person"
                            iconSize="16"
                            className="icon"
                        />
                        <Translate value="profile_completeness.add_avatar" />                         
                    </div>
                    <div className="percentage">
                    <Tag round={true}><strong>+15%</strong></Tag>
                    </div>
                </div>
                <div className={`completeness-item ${has_address?"completed":""}`}>
                    <div className="label">          
                        <Icon
                            icon="map-marker"
                            iconSize="16"
                            className="icon"
                        />
                        <Translate value="profile_completeness.add_address" />
                    </div>
                    <div className="percentage">
                        <Tag round={true}><strong>+50%</strong></Tag>
                    </div>
                </div>
                <div className={`completeness-item ${has_biography?"completed":""}`}>
                    <div className="label">          
                        <Icon
                            icon="citation"
                            iconSize="16"
                            className="icon"
                        />
                        <Translate value="profile_completeness.about_you" />
                    </div>
                    <div className="percentage">
                        <Tag round={true}><strong>+35%</strong></Tag>
                    </div>
                </div>
            </div>
            }
            </>
        )
    }
}

const mapStateToProps = state => ({
    locale: state.i18n.locale,   
    myGuid: loggedInUserGuid(state),
    my_profile: getUserWithId(state, loggedInUserGuid(state))
  });

  const mapDispatchToProps = dispatch => ({   
    fetchUser: id=> dispatch(fetchUser(id))
  });
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProfileCompleteness);
  